var React = require('react');

function FlagJm (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 88.276H8.828A8.828 8.828 0 000 97.103v317.793a8.829 8.829 0 008.828 8.828h494.345a8.829 8.829 0 008.828-8.828V97.103a8.83 8.83 0 00-8.829-8.827z","fill":"#73af00","key":0}),React.createElement("path",{"d":"M512 97.103a8.829 8.829 0 00-8.828-8.828h-39.501L256 224.337 48.329 88.276H8.828A8.828 8.828 0 000 97.103v22.836L207.671 256 0 392.061v22.836a8.829 8.829 0 008.828 8.828h39.501L256 287.663l207.671 136.061h39.501a8.829 8.829 0 008.828-8.828V392.06L304.329 256 512 119.939V97.103z","fill":"#ffe15a","key":1}),React.createElement("g",{"fill":"#464655","key":2},React.createElement("path",{"d":"M512 119.939v272.122L304.329 256zM0 392.061V119.939L207.671 256z"}))]);
}

FlagJm.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagJm;

FlagJm.default = FlagJm;
